































































import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { VNode } from 'vue';
import { throttle, get } from 'lodash';
import MainMenuComplexTabsMetaMixin from '@/views/layout/navigation/mixins/main-menu-complex-tabs-meta-mixin';
import { DrillFilterOptionsEnum } from '@/services/models/Enums';
import UrlMixin, { ExcludeTypeEnum } from '@/components/query/url-mixin';
import MenuDrilldownMenuListItem from '@/views/reports/views/menu-drilldown/menu-drilldown-menu-list-item.vue';

export interface MenuDrilldownBreadcrumbsWidths {
  widths: number[];
  dividerWidth: number;
}

@Component({
  components: {
    MenuDrilldownMenuListItem
  }
})
export default class MenuDrilldownBreadcrumbs extends mixins(UrlMixin, MainMenuComplexTabsMetaMixin) {
  @Prop()
  drill: any[];

  @Prop()
  shadow: boolean;

  @Emit('click')
  onClick(index: number) {}

  @Emit('close')
  onClose(index: number) {}

  @Emit('resize')
  onResize(data: MenuDrilldownBreadcrumbsWidths) {}

  @Emit('slice-exclude')
  onSliceExclude(data: Bemob.ReportQueryDrill) {}

  menu: boolean = false;
  menuOpened: {[type: string]: boolean} = {};
  widths: number[] = [];

  handleItemClick(item: any) {
    if(item.children && item.children.length) {
      this.handleMenu(item.key);
    } else {
      this.onClick(item.index);
    }
  }

  handleMenu(key: string) {
    this.$set(this.menuOpened, key, !this.menuOpened[key]);
    //this.menuOpened[key] = !this.menuOpened[key]
  }

  getMenuList(item: any): Bemob.ListItem[] {
    const children: any[] = item.children;
    const closeToTheRight: Bemob.ListItem = {
      key: 'closeToTheRight',
      title: 'Close to the right',
      click: () => this.onClick(item.index)
    }

    let result = children
      .map<Bemob.ListItem>((item, index) => ({
        key: index,
        title: item.text,
        meta: item
      }))

    if(!item.last) {
      result.push(closeToTheRight);
    }

    return result;
  }

  mounted() {
    if(this.shadow) {
      //window.addEventListener('resize', this.onWindowResizeThrottled);
    }
  }

  beforeDestroy() {
    if(this.shadow) {
      //window.removeEventListener('resize', this.onWindowResizeThrottled);
    }
  }

  get onWindowResizeThrottled() {
    return throttle(this.onWindowResize, 500);
  }

  onWindowResize() {
    this.recalcChipsWidth();
  }

  getIcon(item: Bemob.ReportQueryDrill) {
    return item.filterOptions === DrillFilterOptionsEnum.not_equals 
      ? 'far fa-page-break'
      : 'far fa-random';
  }

  getGrouping(type: string) {
    const key = `[${type}].title`;
    const title: string = get(this.tabsMeta, key, null);

    return title || '';
  }

  getText(item: any) {
    let result = [
      item.text
    ];

    if(item.children && item.children.length > 1) {
      result.push(`[+${item.children.length - 1}]`);
    }

    return result.join(' ');
  }

  @Watch('drill', { immediate: true, deep: true })
  onDrillChanged(value: any[]) {
    if(this.shadow) {
      this.$helpers.afterBrowserRedraw(() => {
        this.recalcChipsWidth(value);
      });
    }
  } 

  recalcChipsWidth(value: any[] = this.drill) {
    this.widths = value.map((item) => {
      const index =  `chip_${item.index}`;
      const node = this.$refs[index] as Vue;
      const el = node?.$el;
      const rect = el?.getBoundingClientRect?.();
      
      return rect?.width;
    });

    const result: MenuDrilldownBreadcrumbsWidths = {
      widths: this.widths,
      dividerWidth: 16
    }

    this.onResize(result);
  }
}
